const header = document.querySelector('[data-header]');
const menuButton = document.querySelector('.menu-button');
const mobileMenu = document.querySelector('#mobile-menu');
const toast = document.querySelector('[data-toast-region]');
const video = document.querySelector('.process-video video');
const videoControl = document.querySelector('[data-video-control]');
const colorTrack = document.querySelector('.color-gallery-track');
const colorMotionControl = document.querySelector('[data-color-motion]');
const materialCarousel = document.querySelector('[data-material-carousel]');
let toastTimer;

document.querySelectorAll('[data-whatsapp-context]').forEach(link => {
  link.addEventListener('click', () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'home_whatsapp_click', context: link.dataset.whatsappContext || 'geral' });
  });
});

function updateHeader() {
  header.classList.toggle('scrolled', window.scrollY > 60);
}

function closeMenu() {
  menuButton.setAttribute('aria-expanded', 'false');
  mobileMenu.hidden = true;
  menuButton.querySelector('.sr-only').textContent = 'Abrir menu';
}

menuButton.addEventListener('click', () => {
  const open = menuButton.getAttribute('aria-expanded') === 'true';
  menuButton.setAttribute('aria-expanded', String(!open));
  mobileMenu.hidden = open;
  menuButton.querySelector('.sr-only').textContent = open ? 'Abrir menu' : 'Fechar menu';
  if (!open) mobileMenu.querySelector('a').focus();
});

mobileMenu.addEventListener('click', event => {
  if (event.target.matches('a')) closeMenu();
});

document.addEventListener('keydown', event => {
  if (event.key === 'Escape' && !mobileMenu.hidden) {
    closeMenu();
    menuButton.focus();
  }
});

document.querySelectorAll('[data-toast]').forEach(button => {
  button.addEventListener('click', () => {
    toast.textContent = button.dataset.toast;
    toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('show'), 3500);
  });
});

window.addEventListener('scroll', updateHeader, { passive: true });
updateHeader();

if (video && videoControl) {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const videoFigure = video.closest('.process-video');
  let userPaused = false;

  function syncVideoControl() {
    const label = video.paused ? 'Reproduzir vídeo' : 'Pausar vídeo';
    videoControl.textContent = label;
    videoControl.setAttribute('aria-label', label);
    videoFigure.classList.toggle('is-paused', video.paused);
  }

  function playVideo() {
    const playback = video.play();
    if (playback && typeof playback.catch === 'function') playback.catch(syncVideoControl);
  }

  video.muted = true;
  video.addEventListener('play', syncVideoControl);
  video.addEventListener('pause', syncVideoControl);
  video.addEventListener('error', syncVideoControl);
  videoControl.addEventListener('click', () => {
    if (video.paused) {
      userPaused = false;
      playVideo();
    } else {
      userPaused = true;
      video.pause();
    }
  });
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting && !reduceMotion.matches && !userPaused && video.paused) playVideo();
      if (!entries[0].isIntersecting && !video.paused) video.pause();
    }, { threshold: 0.2 });
    observer.observe(video);
  } else if (!reduceMotion.matches) {
    playVideo();
  }
  reduceMotion.addEventListener('change', () => {
    if (reduceMotion.matches) video.pause();
    else if (!userPaused) playVideo();
  });
  syncVideoControl();
}

if (colorTrack) {
  const colorSet = colorTrack.querySelector('.color-gallery-set');
  if (colorSet && colorTrack.children.length === 1) {
    const clone = colorSet.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    colorTrack.appendChild(clone);
  }
}

if (colorTrack && colorMotionControl) {
  colorMotionControl.addEventListener('click', () => {
    const paused = colorTrack.classList.toggle('is-paused');
    colorMotionControl.setAttribute('aria-pressed', String(paused));
    colorMotionControl.setAttribute('aria-label', paused ? 'Retomar movimento das placas' : 'Pausar movimento das placas');
    colorMotionControl.textContent = paused ? 'Retomar' : 'Pausar';
  });
}

if (materialCarousel) {
  const viewport = materialCarousel.querySelector('[data-material-viewport]');
  const slides = [...materialCarousel.querySelectorAll('[data-material-slide]')];
  const dots = [...materialCarousel.querySelectorAll('[data-material-dot]')];
  const previous = materialCarousel.querySelector('[data-material-prev]');
  const next = materialCarousel.querySelector('[data-material-next]');
  const motion = materialCarousel.querySelector('[data-material-motion]');
  const status = materialCarousel.querySelector('[data-material-status]');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let activeIndex = 0;
  let autoplayPaused = reduceMotion;
  let timer;
  let dragging = false;
  let dragStartX = 0;
  let dragStartScroll = 0;

  const setActive = index => {
    activeIndex = (index + slides.length) % slides.length;
    dots.forEach((dot, dotIndex) => dot.setAttribute('aria-current', String(dotIndex === activeIndex)));
    status.textContent = `Foto ${activeIndex + 1} de ${slides.length}`;
  };
  const stopTimer = () => { window.clearInterval(timer); timer = undefined; };
  const startTimer = () => {
    stopTimer();
    if (!autoplayPaused && !reduceMotion) timer = window.setInterval(() => goTo(activeIndex + 1), 6500);
  };
  const pauseAutoplay = () => {
    autoplayPaused = true;
    stopTimer();
    motion.setAttribute('aria-pressed', 'true');
    motion.setAttribute('aria-label', 'Retomar passagem automática das fotos');
    motion.textContent = 'Retomar';
  };
  const goTo = (index, userInitiated = false) => {
    setActive(index);
    viewport.scrollTo({ left: slides[activeIndex].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
    if (userInitiated) pauseAutoplay();
  };
  const resumeAutoplay = () => {
    autoplayPaused = false;
    motion.setAttribute('aria-pressed', 'false');
    motion.setAttribute('aria-label', 'Pausar passagem automática das fotos');
    motion.textContent = 'Pausar';
    startTimer();
  };

  previous.addEventListener('click', () => goTo(activeIndex - 1, true));
  next.addEventListener('click', () => goTo(activeIndex + 1, true));
  dots.forEach((dot, index) => dot.addEventListener('click', () => goTo(index, true)));
  motion.addEventListener('click', () => autoplayPaused ? resumeAutoplay() : pauseAutoplay());
  viewport.addEventListener('pointerdown', event => {
    if (event.pointerType === 'mouse' && event.button !== 0) return;
    dragging = true;
    dragStartX = event.clientX;
    dragStartScroll = viewport.scrollLeft;
    viewport.classList.add('is-dragging');
    viewport.setPointerCapture(event.pointerId);
    pauseAutoplay();
  });
  viewport.addEventListener('pointermove', event => {
    if (dragging) viewport.scrollLeft = dragStartScroll - (event.clientX - dragStartX);
  });
  const finishDrag = event => {
    if (!dragging) return;
    dragging = false;
    viewport.classList.remove('is-dragging');
    if (viewport.hasPointerCapture(event.pointerId)) viewport.releasePointerCapture(event.pointerId);
    const closestIndex = slides.reduce((best, slide, index) => {
      const distance = Math.abs(slide.offsetLeft - viewport.scrollLeft);
      return distance < best.distance ? { index, distance } : best;
    }, { index: 0, distance: Infinity }).index;
    goTo(closestIndex);
  };
  viewport.addEventListener('pointerup', finishDrag);
  viewport.addEventListener('pointercancel', finishDrag);
  viewport.addEventListener('keydown', event => {
    if (event.key === 'ArrowLeft') { event.preventDefault(); goTo(activeIndex - 1, true); }
    if (event.key === 'ArrowRight') { event.preventDefault(); goTo(activeIndex + 1, true); }
  });
  viewport.addEventListener('scroll', () => {
    window.clearTimeout(viewport.scrollEndTimer);
    viewport.scrollEndTimer = window.setTimeout(() => {
      const closestIndex = slides.reduce((best, slide, index) => {
        const distance = Math.abs(slide.offsetLeft - viewport.scrollLeft);
        return distance < best.distance ? { index, distance } : best;
      }, { index: 0, distance: Infinity }).index;
      setActive(closestIndex);
    }, 100);
  }, { passive: true });
  materialCarousel.addEventListener('mouseenter', stopTimer);
  materialCarousel.addEventListener('mouseleave', startTimer);
  materialCarousel.addEventListener('focusin', stopTimer);
  materialCarousel.addEventListener('focusout', startTimer);
  window.addEventListener('resize', () => goTo(activeIndex));
  setActive(0);
  startTimer();
}

const historyTimeline = document.querySelector('[data-history-timeline]');

if (historyTimeline) {
  const events = [...historyTimeline.querySelectorAll('.history-event')];
  let dragging = false;
  let startX = 0;
  let startScroll = 0;

  historyTimeline.addEventListener('pointerdown', event => {
    if (event.pointerType === 'mouse' && event.button !== 0) return;
    dragging = true;
    startX = event.clientX;
    startScroll = historyTimeline.scrollLeft;
    historyTimeline.classList.add('is-dragging');
    historyTimeline.setPointerCapture(event.pointerId);
  });
  historyTimeline.addEventListener('pointermove', event => {
    if (dragging) historyTimeline.scrollLeft = startScroll - (event.clientX - startX);
  });
  const finishHistoryDrag = event => {
    if (!dragging) return;
    dragging = false;
    historyTimeline.classList.remove('is-dragging');
    if (historyTimeline.hasPointerCapture(event.pointerId)) historyTimeline.releasePointerCapture(event.pointerId);
  };
  historyTimeline.addEventListener('pointerup', finishHistoryDrag);
  historyTimeline.addEventListener('pointercancel', finishHistoryDrag);
  historyTimeline.addEventListener('keydown', event => {
    if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
    event.preventDefault();
    const direction = event.key === 'ArrowRight' ? 1 : -1;
    const closest = events.reduce((best, item, index) => {
      const distance = Math.abs(item.offsetLeft - historyTimeline.scrollLeft);
      return distance < best.distance ? { index, distance } : best;
    }, { index: 0, distance: Infinity });
    const target = events[Math.max(0, Math.min(events.length - 1, closest.index + direction))];
    target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest', inline: 'start' });
  });
}
